import { FadeIn } from '@/components/custom/fade-in';

/**
 * Standard page/section header: mono eyebrow, Playfair heading with the
 * italic-peach accent word, optional subtitle. The accent renders after
 * `titleStart` (pass accentFirst to flip the order).
 */
export function PageHeader({
  eyebrow,
  titleStart,
  titleAccent,
  titleEnd,
  subtitle,
  as: Heading = 'h1',
  id,
}: {
  eyebrow?: string;
  titleStart: string;
  titleAccent?: string;
  titleEnd?: string;
  subtitle?: string;
  as?: 'h1' | 'h2';
  id?: string;
}) {
  return (
    <FadeIn y={12} duration={0.6}>
      <header className="flex flex-col gap-4">
        {eyebrow && <p className="font-mono text-xs tracking-[1.44px] text-primary uppercase">{eyebrow}</p>}
        <Heading
          id={id}
          className="font-display text-4xl md:text-5xl lg:text-[56px] lg:leading-[64px] font-bold text-foreground"
        >
          {titleStart}
          {titleAccent && (
            <>
              {' '}
              <span className="italic text-primary">{titleAccent}</span>
            </>
          )}
          {titleEnd && <> {titleEnd}</>}
        </Heading>
        {subtitle && <p className="max-w-[640px] text-lg leading-7 text-foreground-soft">{subtitle}</p>}
      </header>
    </FadeIn>
  );
}
